import { createTransform } from "redux-persist";
import { encryptAuth, decryptAuth } from "../util/crypto";

/**
 * Redux Persist transform for the 'auth' slice.
 * - Encrypts the auth state before saving to storage.
 * - Decrypts the auth state when loading from storage.
 * - Only applies to the 'auth' slice (whitelist).
 */
export const authTransform = createTransform(
    // Called when saving state: encrypt the inbound auth state
    (inboundState: object, key) => {
        try {
            return encryptAuth(inboundState);
        } catch (error) {
            console.error("Error encrypting auth state:", error);
            return ""; // fallback to avoid breaking persist
        }
    },

    // Called when loading state: decrypt the outbound auth state
    (outboundState: string, key) => {
        try {
            return decryptAuth(outboundState);
        } catch (error) {
            console.error("Error decrypting auth state:", error);
            return {}; // fallback to avoid breaking the app
        }
    },

    // Only apply this transform to the 'auth' slice
    { whitelist: ["auth"] }
);